import { render, staticRenderFns } from "./ModuleSelectClient.vue?vue&type=template&id=099226f6&scoped=true&lang=pug&"
import script from "./ModuleSelectClient.vue?vue&type=script&lang=js&"
export * from "./ModuleSelectClient.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSelectClient.vue?vue&type=style&index=0&id=099226f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099226f6",
  null
  
)

export default component.exports